const CDN_BASE_URL = import.meta.env.VITE_APP_CDN_URL as string;

export const withCdnUrl = (path: string): string => {
  if (!path) return '';

  if (!CDN_BASE_URL) {
    console.warn('CDN_BASE_URL is not defined');
    return path;
  }

  // Already CDN
  if (path.startsWith(CDN_BASE_URL)) return path;

  // Remove domain if full URL
  // const cleanPath = path.replace(/^https?:\/\/[^/]+/, '');

  // console.log('Path after CDN processing:', cleanPath);

  // const withCdnUrl = `${CDN_BASE_URL}${cleanPath.startsWith('/') ? '' : '/'}${cleanPath}`;
  const withCdnUrl = `${CDN_BASE_URL}/review-images/${path}`;

  return withCdnUrl;
};
